import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "download3--sprite",
  "use": "download3--sprite-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"download3--sprite\">\n<path d=\"M13.1663 6.33337H10.4997V2.33337H6.49967V6.33337H3.83301L8.49967 11L13.1663 6.33337ZM7.83301 7.66671V3.66671H9.16634V7.66671H9.94634L8.49967 9.11337L7.05301 7.66671H7.83301ZM3.83301 12.3334H13.1663V13.6667H3.83301V12.3334Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol